export function isPDFFile(fileName: string): boolean {
  const fileExtension = `.${fileName.split('.').pop()?.toLowerCase() || ''}`;
  return fileExtension === '.pdf';
}
